import axios from "axios";
import router from "../router";
import {Indicator, MessageBox, Toast} from "mint-ui";
import appConfig from "./appConfig";

if (appConfig.interface == 1) {  
  // 正式
  // axios.defaults.baseURL = "http://klb.rssyjt.cn/fjlm/rest/";
 // axios.defaults.baseURL = "http://www.fujinmeng.com/fjlm/rest/";
 axios.defaults.baseURL = "http://www.fjfapiao.com:2018/fjbw/sbsp/api";
} else if (appConfig.interface == 2) {
  // 开发
  //axios.defaults.baseURL = "http://192.168.1.169:9080/fjlm/rest/";
  axios.defaults.baseURL = "http://www.fjfapiao.com:2018/fjbw/sbsp/api/";
} else if (appConfig.interface == 3){
  //测试
  // axios.defaults.baseURL = "http://192.168.1.222:9080/fjlm/rest/";
  axios.defaults.baseURL = "http://localhost:2018/fjbw/sbsp/api/";
} else if (appConfig.interface == 4){
  //测试
  // axios.defaults.baseURL = "http://192.168.1.222:9080/fjlm/rest/";
  axios.defaults.baseURL = "http://www.fjbwjf.com/test/bwjf/invoice/api/";
}else if(appConfig.interface == 5){

  axios.defaults.baseURL = "http://localhost:9080/bwjf/invoice/api/";
}else if(appConfig.interface == 6){
  //测试1
  axios.defaults.baseURL = "http://localhost:9080/bwjf/invoice/api/";
}else{
  //测试1
  axios.defaults.baseURL = "http://localhost:9080/bwjf/invoice/api/";
}
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
axios.defaults.headers.put["Content-Type"] = "application/json;charset=utf-8";
axios.defaults.headers.get["Content-Type"] = "application/json;charset=utf-8";
axios.interceptors.request.use(
    config => {
      if (config.url.indexOf("restapi.amap.com") == -1) {
        config.headers["authorization"] = localStorage.getItem("sanitationAccessToken");
        config.headers["api-version"] = appConfig.version;
        if (sessionStorage.getItem("bussToken"))
          config.headers["businessAuthorization"] = sessionStorage.getItem(
              "bussToken"
          );
      }
      return config;
    },
    error => {
      Promise.reject(error);
    }
);
axios.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      if (error && error.response) {
        switch (error.response.status) {
          case 400:
            error.message = "错误请求";
            break;
          case 401:
            error.message = "未授权，请重新登录";
            break;
          case 403:
            error.message = "操作太频繁，请稍后重试";
            break;
          case 404:
            error.message = "请求错误,未找到该资源";
            break;
          case 405:
            error.message = "请求方法未允许";
            break;
          case 408:
            error.message = "请求超时";
            break;
          case 500:
            error.message = "服务器端出错";
            break;
          case 501:
            error.message = "网络未实现";
            break;
          case 502:
            error.message = "网络错误";
            break;
          case 503:
            error.message = "服务不可用";
            break;
          case 504:
            error.message = "网络超时";
            break;
          case 505:
            error.message = "http版本不支持该请求";
            break;
          default:
            error.message = `连接错误${error.response.status}`;
        }
      } else {
        error.message = "网络出现问题,请稍后再试";
      }
      if(error.message == "网络出现问题,请稍后再试"){
        try {
          Indicator.close();
        } catch (error) {
        }
        return Promise.reject(error);
      } else{
        console.log(error.response.status);
        if (error.response.status == 401) {
          var is401 = localStorage.getItem("to401Login");
          if (is401) {
            console.log("10秒内的401不做重新登录");
            try {
              setTimeout(() => {
                localStorage.removeItem("to401Login");
              }, 5000);
            } catch (error) {
            }
          } else {

            let l_wasAgreed = localStorage.getItem("loginWasAgreed");
            let lastVersion = localStorage.getItem("version_code");
            let phone = localStorage.getItem("phone");
            let logFailObj = '';
            if (window.plus){
              logFailObj = localStorage.getItem("logFailObj");
            }
            localStorage.clear();
            localStorage.setItem("to401Login", true);
            setTimeout(() => {
              localStorage.removeItem("to401Login");
            }, 10000);
            // 保存初始的localStorage
            if (l_wasAgreed && l_wasAgreed != "null") {
              localStorage.setItem("loginWasAgreed", l_wasAgreed);
            }
            if (lastVersion && lastVersion != "null") {
              localStorage.setItem("version_code", lastVersion);
            }
            if (phone && phone != "null") {
              localStorage.setItem("phone", phone);
            }
            if (window.plus&&logFailObj){// 不清空操作日志
              localStorage.setItem("logFailObj", logFailObj);
            }
           // localStorage.setItem("download_app_status", "1");
            Indicator.close();
            sessionStorage.removeItem("UserInfo");
            MessageBox({
              title: "系统提示",
              message: "用户登录认证过期",
              closeOnClickModal: false
            }).then(action => {
              if (action == "confirm") {
                router.replace({
                  path: "/login",
                  query: {
                    redirect: router.currentRoute.fullPath
                  }
                });
                return Promise.reject(error);
              }
            });
          }
        } else {
          Toast({
            message: error.message,
            position: "middle",
            duration: 2000
          });
          Indicator.close();
          return Promise.reject(error);
        }
      }
    }
);

export default {
  //get请求
  get(url, param = {}) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url,
        params: param
      }).then(res => {
        if(res!=undefined){
          resolve(res.data);
        }
       
      }).catch(error => {
        reject(error);
      });
    });
  },
  //post请求
  post(url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url,
        data: param
      })
          .then(res => {
            resolve(res.data);
          })
          .catch(error => {
            reject(error);
          });
    });
  }
};
